/**
 * Returns the trigger data
 *
 * @param {Number} itemID The item ID
 * @return {Object} The item
 */
const getItemTrigger = ( itemID ) => {
	return UncannyAutomator._recipe.triggers.items.find( item => item.id === itemID );
}

export default getItemTrigger;
